import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

/**
 * Renders assistant message content as markdown (GFM — tables, strikethrough,
 * task lists, autolinks). Styling rides on the `prose` typography plugin with a
 * handful of token-aware overrides so it sits correctly on both light and dark
 * surfaces. External links open in a new tab.
 */
export const CopilotMarkdown: React.FC<{ content: string }> = ({ content }) => {
  return (
    <div
      className="prose prose-sm dark:prose-invert max-w-none
        prose-p:my-2 prose-headings:mt-3 prose-headings:mb-2
        prose-pre:bg-surface-tertiary prose-pre:text-txt-primary prose-pre:border prose-pre:border-border
        prose-code:text-brand-700 dark:prose-code:text-brand-300 prose-code:before:content-[''] prose-code:after:content-['']
        prose-a:text-brand-600 dark:prose-a:text-brand-400
        prose-table:text-sm prose-th:border prose-th:border-border prose-td:border prose-td:border-border
        prose-th:px-2 prose-th:py-1 prose-td:px-2 prose-td:py-1
        prose-blockquote:border-l-brand-400 prose-blockquote:text-txt-secondary
        prose-li:my-0.5"
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node: _node, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer" />
          ),
          table: ({ node: _node, ...props }) => (
            <div className="overflow-x-auto">
              <table {...props} />
            </div>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
